import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import GareTableRow from './GareTableRow'
import TablePager from '../TablePager'
import TableColumnOrdered from '../TableColumnOrdered'
import PropTypes from 'prop-types';
import PdfButton from "../PdfButton";

class GareTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
        this.onPdfExportClick = this.onPdfExportClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }

    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    onPdfExportClick(tipo){
        if (this.props.onExportPdf !== undefined){
            this.props.onExportPdf(tipo)
        }
    }

    render() {
        let btnNuovaGara = null;
        if (this.props.readOnly == false){
            btnNuovaGara =<Link to={`/app/gare/new`}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="plus icon"></i> Nuova Gara/Offerta
                    </div>
                </Link>
        }
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled compact table">
            <thead>
            <tr><th colSpan="11">
                {btnNuovaGara}
                <PdfButton title="PDF Completo" onClick={(ev) => (this.onPdfExportClick("completo"))} />

                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="codice"
                    orderActive={this.props.tableOrderingField === "codice"}
                    orderFields="codice"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Nr.</TableColumnOrdered>
                <TableColumnOrdered
                    name="anno"
                    orderActive={this.props.tableOrderingField === "anno"}
                    orderFields="anno"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Anno</TableColumnOrdered>
                <TableColumnOrdered
                    name="nome"
                    orderActive={this.props.tableOrderingField === "nome"}
                    orderFields="nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Nome</TableColumnOrdered>
                <TableColumnOrdered
                    name="statoGara"
                    orderActive={this.props.tableOrderingField === "statoGara"}
                    orderFields="statoGara"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Stato</TableColumnOrdered>
                <TableColumnOrdered
                    name="dataReg"
                    orderActive={this.props.tableOrderingField === "dataReg"}
                    orderFields="dataReg"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Data reg.</TableColumnOrdered>
                <TableColumnOrdered
                    name="presentazione"
                    orderActive={this.props.tableOrderingField === "presentazione"}
                    orderFields="presentazione"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Presentazione</TableColumnOrdered>
                <TableColumnOrdered
                    name="sopralluogo"
                    orderActive={this.props.tableOrderingField === "sopralluogo"}
                    orderFields="sopralluogo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Sopralluogo</TableColumnOrdered>
                <TableColumnOrdered
                    name="chiarimenti"
                    orderActive={this.props.tableOrderingField === "chiarimenti"}
                    orderFields="chiarimenti"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Chiarimenti</TableColumnOrdered>
                <TableColumnOrdered
                    name="ragioneSociale"
                    orderActive={this.props.tableOrderingField === "ragioneSociale"}
                    orderFields="ragioneSociale"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Cliente</TableColumnOrdered>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="idGara"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >ID</TableColumnOrdered>
                <TableColumnOrdered
                    name="idCommessa"
                    orderActive={this.props.tableOrderingField === "idCommessa"}
                    orderFields="idCommessa"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={false}
                >In Commessa</TableColumnOrdered>
                <TableColumnOrdered
                    name="tipo"
                    orderActive={this.props.tableOrderingField === "tipo"}
                    orderFields="tipo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={true}
                >Tipo di Gara</TableColumnOrdered>
                <TableColumnOrdered
                    name="partecipato"
                    orderActive={this.props.tableOrderingField === "partecipato"}
                    orderFields="partecipato"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                    enabled={false}
                >Partecipato</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((gara) => (
                <GareTableRow
                    gara={gara}
                    key={gara.idGara}
                    lastIdGara={this.props.lastIdGara}
                    onDeleteItem={this.props.onDeleteItem}
                    onCreaCommessa={this.props.onCreaCommessa}
                    readOnly={this.props.readOnly}
                />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

GareTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    lastIdGara: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDeleteItem: PropTypes.func,
    onExportPdf: PropTypes.func,
    onCreaCommessa: PropTypes.func,
    readOnly: PropTypes.bool
}
export default GareTable;




/** WEBPACK FOOTER **
 ** ./src/components/gare/GareTable.js
 **/